import { apiFetch } from "@/api/APIClient";
import { useQuery } from "@tanstack/react-query";

export interface AdminUser {
  uid: string;
  email: string;
  name: string | null;
  nickname: string | null;
  isTestUser: boolean;
  testSettings: {
    testPaymentEnabled: boolean;
  };
}

interface SearchUsersResponse {
  users: AdminUser[];
}

export function useSearchUsers(query: string) {
  return useQuery<SearchUsersResponse, Error>({
    queryKey: ["admin-users", query],
    queryFn: async () => {
      const response = await apiFetch(`api/admin/users?query=${encodeURIComponent(query)}`);

      if (!response.ok) {
        throw new Error("사용자 목록을 불러오지 못했습니다.");
      }

      return response.json();
    },
    enabled: query.trim().length > 0,
  });
}
